module.exports = __webpack_public_path__ + "static/media/stockholm.d52549aa.png";